import { useEffect, useRef } from 'react';

/**
 * Just like useEffect, but not triggered on initial mount
 *
 * This is useful for example for tracking changes to form fields,
 * where you need the change to be already fetched to state.
 */
export const useEffectOnChange: typeof useEffect = (effect, deps) => {
  const isInitialMount = useRef(true);
  // biome-ignore lint/correctness/useExhaustiveDependencies: special use case
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return undefined;
    }
    return effect();
  }, deps);
};
